import React from 'react';
import { Form } from 'react-bootstrap';
import { FaCog } from 'react-icons/fa';

import Const from '../../util/Constants';

class TableHeader extends React.Component {

  render() {
    let headers = [];
    headers = this.props.fields.map(field => {
      if(field.includes(Const.Address) && field.includes(Const.Opt)) {
        const fields = field.split(Const.Opt);
        let fieldName = '';
        if(fields[1] === Const.Street) fieldName = Const.Tstreet;
        else if(fields[1] === Const.City) fieldName = Const.Tcity;
        else if(fields[1] === Const.State) fieldName = Const.Tstate;
        else if(fields[1] === Const.Country) fieldName = Const.Tcountry;
        else if(fields[1] === Const.Pin) fieldName = Const.Tpin;
        return <th key={field}>{fieldName}</th>
      } else {
        return <th key={field}>{this.props.model.fields[field].label_name}</th>
      }
    });

    return (
      <thead>
        <tr>
          <th> 
            <FaCog onClick={this.props.showListPopup} /> 
            { this.props.onSelectAll ?
              <Form.Check type="checkbox">
                <Form.Check.Input type="checkbox" onChange={evt => evt.target.checked 
                  ? this.props.onSelectAll() : this.props.onRemoveAll()} />
                <Form.Check.Label>All</Form.Check.Label>
              </Form.Check>
              : null
            }
          </th>
          {headers}
          <th> Action </th>
        </tr>
      </thead>
    );
  }
}

export default TableHeader;
